import englishMessages from 'ra-language-english';

const customEnglishMessages = {
  ...englishMessages,
  ra: {
    ...englishMessages.ra,
    sort: {
      sort_by: 'Sort by %{field} %{order}',
      ASC: 'ascending',
      DESC: 'descending',
    },
    navigation: {
      ...englishMessages.ra.navigation,
      no_results: 'No results found',
      no_filtered_results: 'No results found for the current filters.',
    },
    page: {
      ...englishMessages.ra.page,
      edit: '%{name} #%{id}',
      show: '%{name} #%{id}',
      empty: 'No %{name} yet.',
    },
  },
  resources: {
    'telegram-products': {
      name: 'Telegram Product |||| Telegram Products',
      fields: {
        title: 'Title',
        description: 'Description',
        price: 'Price',
        photo: 'Photo',
        image: 'Image',
        category: 'Category',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        postedInTelegram: 'Posted in Telegram',
      },
    },
    'promo-codes': {
      name: 'Promo Code |||| Promo Codes',
      fields: {
        code: 'Code',
        discount: 'Discount',
        discountType: 'Discount Type',
        validFrom: 'Valid From',
        validTo: 'Valid To',
        usageLimit: 'Usage Limit',
        usedCount: 'Used Count',
        usageCount: 'Times Used',
        usageLimits: 'Usage Limits',
        usageProgress: 'Usage Progress',
        unlimited: 'Unlimited',
        active: 'Active',
        status: 'Status',
        statusActive: 'Active',
        statusExpiringSoon: 'Expiring Soon',
        statusExpired: 'Expired',
        description: 'Description',
        expiresAt: 'Expires at',
        percentageDiscount: 'Percentage discount %',
        fixedDiscount: 'Fixed discount',
        limitPerUser: 'Limit per user',
        expirationTime: 'Expiration time',
      },
    },
    'product-compositions': {
      name: 'Catalog',
      fields: {
        title: 'Title',
        description: 'Description',
        price: 'Price',
        available: 'Available',
        isAddon: 'Cart add-on',
        photo: 'Photo',
        photos: 'Photos',
        postedToWix: 'Posted to Wix',
        wixProductId: 'Wix Product ID',
        onWix: 'On Wix',
        sku: 'SKU',
        compositionItems: 'Products',
        color: 'Color',
        amount: 'Available',
        rating: 'Rating',
        reviewCount: 'Reviews',
        orderCount: 'Orders',
        labels: 'Labels',
        ingredients: 'Ingredients',
        customizationOptions: 'Customization Options',
        inheritedOptions: 'Comes with this bouquet automatically',
        customizationOptionAdditions: 'Extras for this bouquet only',
        hideOnThisComposition: 'Hide',
        notOfferedOnThisComposition: 'Not offered with this bouquet',
        relatedCompositionIds: 'Related Compositions',
      },
      helpers: {
        customizationOptions: 'Options shown to customers when ordering this bouquet.',
        noInheritedOptions:
          'No options attached yet. Add labels above, mark options as global, or add extras below.',
        customizationOptionAdditions:
          "Add an option just for this bouquet, even if its labels don't match.",
        prunedExclusions:
          '%{count} previously hidden option(s) are no longer available and have been cleared.',
      },
      actions: {
        manageCustomizationOptions: 'Manage all customization options →',
      },
    },
    'admin/catalog-labels': {
      name: 'Label |||| Labels',
      fields: {
        name: 'Name',
        slug: 'Slug',
        isActive: 'Active',
        includeInactive: 'Show inactive',
        translations: 'Translations',
      },
    },
    'attribute-definitions': {
      name: 'Product Property |||| Product Properties',
      fields: {
        slug: 'Slug',
        name: 'Name',
        type: 'Type',
        unit: 'Unit',
        options: 'Options',
        optionValue: 'Value',
        defaultValue: 'Default value',
        defaultMin: 'Default min',
        defaultMax: 'Default max',
        isRequired: 'Required',
        isFilterable: 'Filterable',
        isActive: 'Active',
        displayOrder: 'Display order',
      },
      helpers: {
        slug: 'Stable machine identifier, e.g. "stem-length". Cannot be changed later.',
        slugImmutable: 'The slug cannot be changed after creation.',
        typeImmutable:
          'Type cannot be changed after creation. To change the type, soft-delete this property and create a new one with a fresh slug.',
        name: 'Canonical Czech display name.',
        unit: 'e.g. "cm", "kg", "ks"',
        options: 'One per option. Per-locale labels live below.',
        displayOrder: 'Lower values appear first.',
      },
      sections: {
        optionTranslations: 'Option labels (per locale)',
      },
      types: {
        enum: 'Enum',
        number: 'Number',
        range: 'Range',
        text: 'Text',
        boolean: 'Boolean',
      },
    },
    'admin/customization-options': {
      name: 'Customization Option |||| Customization Options',
      fields: {
        name: 'Name',
        type: 'Type',
        price: 'Price',
        photo: 'Photo URL',
        slug: 'Slug',
        isActive: 'Active',
        isGlobal: 'Global',
        labelIds: 'Labels',
        includeInactive: 'Show inactive',
        translations: 'Translations',
      },
      helpers: {
        photo: 'Optional image URL',
        slugAutoGenerate: 'leave empty to auto-generate from name',
        isGlobal: 'When on, this option appears on every composition regardless of labels.',
        labelIds: 'Attach to compositions that share any of these labels.',
      },
      types: {
        wrapping: 'Wrapping',
        box: 'Box',
        ribbon: 'Ribbon',
        card: 'Card',
        other: 'Other',
      },
    },
    products: {
      name: 'Inventory',
      fields: {
        title: 'Title',
        description: 'Description',
        price: 'Price',
        color: 'Color',
        photo: 'Photo',
        amount: 'Available',
        categoryId: 'Category',
        createdAt: 'Created At',
        availableAmount: 'Available amount',
        rating: 'Rating',
        reviewCount: 'Reviews',
        orderCount: 'Orders',
        flowerTypes: 'Flower Types',
        ingredients: 'Ingredients',
      },
    },
    categories: {
      name: 'Category |||| Categories',
      fields: {
        name: 'Name',
        description: 'Description',
        parentId: 'Parent Category',
      },
    },
    'stock-movements': {
      name: 'Stock Movement |||| Stock Movements',
      fields: {
        productId: 'Product',
        branchId: 'Branch',
        quantity: 'Quantity',
        type: 'Type',
        reason: 'Reason',
        notes: 'Notes',
        createdAt: 'Created At',
        date: 'Date',
        dateFrom: 'Date from',
        dateTo: 'Date to',
        photo: 'Photo',
      },
    },
    'manual-orders': {
      name: 'Order |||| Orders',
      fields: {
        orderNumber: 'Order #',
        customerName: 'Customer Name',
        customerPhone: 'Customer Phone',
        customerEmail: 'Customer Email',
        deliveryAddress: 'Delivery Address',
        deliveryDate: 'Delivery Date',
        deliveryTime: 'Delivery Time',
        status: 'Status',
        totalAmount: 'Total Amount',
        total: 'Total',
        notes: 'Notes',
        items: 'Items',
        createdAt: 'Created At',
        branch: 'Branch',
        fulfillmentType: 'Fulfillment type',
        fulfillment: 'Fulfillment',
        fulfillmentDate: 'Fulfillment date',
        timeRange: 'Time range',
        timeFrom: 'Time from',
        timeTo: 'Time to',
        lead: 'Lead',
        leadContact: 'Lead contact',
        recipientName: 'Recipient Full name',
        recipientPhone: 'Recipient Phone number',
        recipientAddress: 'Recipient Address',
        paymentMethod: 'Payment method',
        comment: 'Comment',
        attachments: 'Attachments',
        products: 'Products',
        clientId: 'Client',
        customRequest: 'Custom request',
        customBudget: 'Custom budget',
        paidAt: 'Payment',
        paid: 'Paid',
        unpaid: 'Unpaid',
        event: 'Event',
      },
    },
    clients: {
      name: 'Client |||| Clients',
      fields: {
        source: 'Source',
        name: 'Name',
        phone: 'Phone',
        email: 'Email',
        instagramHandle: 'Instagram Handle',
        telegramUsername: 'Telegram Username',
        notes: 'Notes',
        branchId: 'Branch',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
        gender: 'Gender',
        birthday: 'Birthday',
        loyaltyTier: 'Loyalty Tier',
        bonusBalance: 'Bonus Balance',
        orders: 'Orders',
      },
    },
    users: {
      name: 'User |||| Users',
      fields: {
        username: 'Username',
        email: 'Email',
        password: 'Password',
        firstName: 'First Name',
        lastName: 'Last Name',
        roles: 'Roles',
        role: 'Role',
        active: 'Active',
        createdAt: 'Created At',
        updatedAt: 'Updated At',
      },
    },
    roles: {
      name: 'Role |||| Roles',
      fields: {
        name: 'Name',
        roleName: 'Role Name',
        description: 'Description',
        permissions: 'Permissions',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
    },
    permissions: {
      name: 'Permission |||| Permissions',
      fields: {
        name: 'Name',
        permissionName: 'Permission Name',
        description: 'Description',
        code: 'Code',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
    },
    branches: {
      name: 'Branch |||| Branches',
      fields: {
        name: 'Name',
        address: 'Address',
        phone: 'Phone',
        email: 'Email',
        isActive: 'Active',
        createdAt: 'Created',
        updatedAt: 'Updated',
        hoursSchedule: 'Opening hours',
      },
      closed: 'Closed',
      open: 'Open',
      close: 'Close',
      hoursSet: '7 days',
      day: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
      validation: {
        openBeforeClose: 'Opening time must be earlier than closing time for every open day.',
      },
    },
    'delivery-time-slots': {
      name: 'Delivery Time Slot |||| Delivery Time Slots',
      fields: {
        key: 'Key',
        label: 'Label',
        startTime: 'Start time',
        endTime: 'End time',
        sortOrder: 'Sort order',
        isActive: 'Active',
      },
      validation: {
        timeFormat: 'Time must be in HH:MM format (00:00 – 23:59).',
        startBeforeEnd: 'End time must be later than start time.',
      },
    },
    'admin/settings': {
      name: 'Settings',
      fields: {
        value: 'Value',
      },
    },
    'mobile-orders': {
      name: 'Mobile Order |||| Mobile Orders',
      fields: {
        status: 'Status',
        deliveryMethod: 'Delivery Method',
        paymentMethod: 'Payment Method',
        total: 'Total',
        clientId: 'Client',
        branchId: 'Branch',
        deliveryDate: 'Delivery Date',
        deliveryTimeSlot: 'Time Slot',
        giftMessage: 'Gift Message',
        promoCode: 'Promo Code',
        notes: 'Notes',
        subtotal: 'Subtotal',
        deliveryFee: 'Delivery Fee',
        discount: 'Discount',
        createdAt: 'Created',
        updatedAt: 'Updated',
        items: 'Items',
        deliveryAddress: 'Delivery Address',
        stripePaymentIntentId: 'Stripe Payment Intent',
      },
    },
    'loyalty-transactions': {
      name: 'Loyalty Transaction |||| Loyalty Transactions',
      fields: {
        type: 'Type',
        amount: 'Amount',
        description: 'Description',
        clientId: 'Client',
        createdAt: 'Created',
      },
    },
    campaigns: {
      name: 'Campaign |||| Campaigns',
      fields: {
        title: 'Title',
        subtitle: 'Subtitle',
        imageUrl: 'Image',
        currentImage: 'Current image',
        ctaLabel: 'CTA Label',
        linkType: 'Link Type',
        linkTarget: 'Link Target',
        backgroundColor: 'Background color',
        isActive: 'Active',
        startsAt: 'Starts at',
        endsAt: 'Ends at',
        priority: 'Priority',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
      linkType: {
        product: 'Product',
        url: 'URL',
      },
      helpers: {
        selectLinkTypeFirst: 'Select a link type first',
        uploadImage: 'Upload banner image',
        replaceImage: 'Replace banner image',
        uploadAfterSave: 'Save the campaign first, then add an image to attach it.',
        hexColor: 'Hex color like #FDF2F8',
      },
      validation: {
        hexColor: 'Must be a hex color like #FDF2F8',
        url: 'Must be a valid http(s) URL',
      },
    },
    events: {
      name: 'Event |||| Events',
      fields: {
        title: 'Title',
        description: 'Description',
        deliveryStartDate: 'Delivery start',
        deliveryEndDate: 'Delivery end',
        maxPerDay: 'Max orders per day',
        branchId: 'Branch',
        deliveryFee: 'Delivery fee',
        currency: 'Currency',
        allowedCategoryIds: 'Allowed categories',
        allowedProductIds: 'Allowed bouquets',
        contactPhone: 'Recipient phone',
        contactData: 'Recipient name',
        defaultAddress: 'Default delivery address',
        isActive: 'Active',
        createdAt: 'Created',
        updatedAt: 'Updated',
      },
      sections: {
        pricing: 'Pricing',
        catalogScope: 'Catalog scope',
        contact: 'Contact & delivery',
      },
      helpers: {
        titleFallback: 'Czech (primary) title. Shown to Czech guests and used as the fallback for any locale without a translation.',
        descriptionFallback: 'Czech (primary) description. Shown to Czech guests and used as the fallback for any locale without a translation.',
        maxPerDay: 'A date becomes unavailable once this many orders are held for it. Default 1.',
        branch: 'Fulfilling branch. Required — guest orders inherit this branch.',
        deliveryFee: 'Added to every order. Leave empty to use the global app setting.',
        catalogScope:
          'Leave the bouquet picker empty to offer all active catalog bouquets. Otherwise guests see only the selected bouquets.',
        defaultAddress: 'Prefilled for guests but editable during checkout.',
      },
      copyLink: {
        sectionLabel: 'Guest link',
        label: 'Public guest URL',
        helper: 'Encode this URL in the QR code printed for the event.',
        button: 'Copy link',
        copied: 'Guest link copied to clipboard',
        copyFailed: 'Could not copy — select the field and copy manually.',
      },
    },
  },
  branches: {
    latitude: 'Latitude',
    longitude: 'Longitude',
    latitudeHelper: "Right-click on Google Maps → 'What's here?' to copy. Range -90 to 90.",
    longitudeHelper: "Right-click on Google Maps → 'What's here?' to copy. Range -180 to 180.",
  },
  app: {
    language: 'Language',
    branch: 'Branch',
    allBranches: 'All branches',
    search: 'Search',
    cancel: 'Cancel',
    back: 'Back',
    add: 'Add',
    clear: 'Clear',
    loading: 'Loading...',
    noResults: 'No results found',
    actions: 'Actions',
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome to MoonFlowers Admin Panel',
      selectResource: 'Select a resource from the menu to get started.',
      ordersAttention: 'Orders needing attention',
      noOrdersAttention: 'All clear! No pending orders.',
      lowStock: 'Low stock alerts',
      noLowStock: 'All products are well stocked.',
      quickActions: 'Quick actions',
      newOrder: 'New Order',
      newProduct: 'New Product',
      viewAnalytics: 'View Analytics',
      revenueLast7: '7-day revenue',
    },
    menu: {
      dashboard: 'Dashboard',
      analytics: 'Analytics',
      orders: 'Orders',
      products: 'Products',
      clients: 'Clients',
      channels: 'Channels',
      settings: 'Settings',
      catalog: 'Catalog',
      inventory: 'Inventory',
      telegramBot: 'Telegram Bot',
      deliveries: 'Deliveries',
      sales: 'Sales',
      administration: 'Administration',
      dotykacka: 'Dotykacka',
      loyaltyScan: 'Bonus Scanner',
    },
    loyalty: {
      success: 'Bonus transaction recorded',
      errors: {
        invalidAmount: 'Enter a positive amount',
        insufficientBalance: 'Amount exceeds the available bonus balance',
      },
      dialog: {
        title: 'Bonus management — %{name}',
        balance: 'Balance',
        tier: 'Tier',
        earn: 'Earn',
        redeem: 'Redeem',
        amount: 'Amount (CZK)',
        orderId: 'Order ID (optional)',
        orderIdHelp: 'Link this transaction to an order. Required for redemption rules (cap, min order).',
        description: 'Description',
        confirmEarn: 'Credit bonus',
        confirmRedeem: 'Redeem bonus',
      },
      scan: {
        title: 'Bonus Scanner',
        subtitle: 'Scan a customer QR from the mobile app to look up their loyalty profile and process bonuses.',
        cameraTitle: 'QR camera',
        manualTitle: 'Manual lookup',
        manualPlaceholder: 'Paste loyalty token',
        lookup: 'Look up',
        start: 'Start camera',
        stop: 'Stop',
        cameraError: 'Could not access the camera',
        empty: 'Scan a QR or paste a loyalty token to begin.',
        resultTitle: 'Customer',
        recent: 'Recent transactions',
        refresh: 'Refresh',
      },
    },
    analytics: {
      title: 'Analytics',
      subtitle: 'Current month overview',
      ordersToday: 'Orders today',
      ordersYesterday: 'Orders yesterday',
      ordersThisWeek: 'This week',
      ordersThisMonth: 'This month',
      byStatus: 'Orders by status',
      byLeadSource: 'Orders by lead source',
      fulfillmentSplit: 'Pickup vs Delivery',
      revenueByBranch: 'Revenue by branch',
      noData: 'No orders for the selected period.',
      presetToday: 'Today',
      presetWeek: 'This week',
      presetMonth: 'This month',
      presetLastMonth: 'Last month',
      revenueTrend: 'Revenue trend',
      byPaymentMethod: 'Orders by payment method',
      showRevenue: 'Revenue',
      showOrders: 'Orders',
      rangeTotalOrders: 'Total orders',
      rangeTotalRevenue: 'Total revenue',
      rangeAvgOrderPrice: 'Avg order price',
    },
    filters: {
      createdFrom: 'Created from',
      createdTo: 'Created to',
    },
    wix: {
      integration: 'Wix Integration',
      currentStatus: 'Current status:',
      publishedOnWix: 'Published on Wix',
      notPublished: 'Not published',
      wixProductId: 'Wix Product ID',
      publishToWix: 'Publish to Wix',
      toggleOffToUnpublish: 'Published to Wix (toggle off to unpublish)',
      willBeVisible: 'This composition will be visible in your Wix store. Any updates will sync automatically.',
      enableToPublish: 'Enable to publish this composition to your Wix store.',
    },
    validation: {
      charactersLimit: '%{current}/%{max} characters',
      dateMustBeFuture: 'Date must be today or in the future',
      maxCharacters: 'Max %{max} characters',
      duplicateProduct: 'A product with this title already exists',
      duplicateCategory: 'A category with this name already exists',
    },
    stock: {
      movement: 'Stock Movement',
      in: 'Stock In',
      out: 'Stock Out',
      supply: 'Supply',
      writeOff: 'Write-off',
      orderWriteOff: 'Order Write-off',
      adjustment: 'Adjustment',
      uploadImage: 'Upload Image (optional)',
      waste: {
        title: 'Ineffective flowers',
        subtitle: 'Share of consumed stock written off as waste vs used in orders',
        rate: 'Waste rate',
        minNote: 'Products with at least %{min} pcs consumed in the period',
        empty: 'No write-offs in the selected period',
      },
      batchIntake: {
        menuTitle: 'Batch Intake',
        title: 'Batch Stock Intake',
        subtitle: 'Quickly add stock to multiple products at once',
        addRow: 'Add product',
        submit: 'Submit intake',
        selectBranch: 'Please select a branch first',
        addProducts: 'Please add at least one product with a quantity',
        success: '%{count} stock movement(s) created successfully',
        partialSuccess: '%{succeeded} succeeded, %{failed} failed',
        reason: 'Batch intake',
        preview: '%{count} product(s), %{total} total units will be added',
      },
    },
    order: {
      status: {
        todo: 'Todo',
        inProgress: 'In Progress',
        ready: 'Ready',
        delivering: 'Delivering',
        done: 'Done',
        cancelled: 'Cancelled',
      },
      statusEmoji: {
        todo: 'Todo',
        inProgress: 'In Progress',
        ready: 'Ready',
        delivering: 'Delivering',
        done: 'Done',
        cancelled: 'Cancelled',
      },
      newOrderStatus: 'New orders always start with "Todo" status',
      noComment: 'No comment',
      notSpecified: 'Not specified',
      noProducts: 'No products',
      noAttachments: 'No attachments',
      from: 'from',
      until: 'until',
      itemsSummary: 'Items Summary:',
      productsInOrder: 'Products in order *',
      searchProducts: 'Search products',
      typeToSearch: 'Type to search or scroll...',
      outOfStock: 'Out of stock',
      available: '%{count} available',
      noProductsFound: 'No products found',
      noProductsAdded: 'No products added yet. Search and add products above.',
      calculatedTotal: 'Calculated total:',
      qty: 'Qty',
      sum: 'Sum',
      action: 'Action',
      commentOptional: 'Comment (optional)',
      deliveryDetails: 'Delivery Details',
      leadInformation: 'Lead Information',
      orderStatus: 'Order Status',
      orderTotal: 'Order Total',
      eventDetails: 'Event Details',
      payment: 'Payment',
      uploadImages: 'Upload images (optional)',
      recipientAddressDelivery: 'Recipient Address (for delivery)',
      searchClientsHint: 'Search existing clients or leave blank',
      notifications: {
        loadProductDetailsFailed: 'Failed to load product details',
        loadProductsFailed: 'Failed to load products',
      },
    },
    fulfillment: {
      pickup: 'Pickup',
      delivery: 'Delivery',
    },
    paymentMethod: {
      notPaid: 'Not paid',
      raiffaisen: 'Raiffaisen',
      cash: 'Cash',
      revolut: 'Revolut',
      uaCard: 'UA card',
      crypto: 'Crypto',
      paypal: 'PayPal',
      wise: 'Wise',
      iban: 'IBAN',
    },
    leadSource: {
      instagram: 'Instagram',
      telegram: 'Telegram',
      whatsapp: 'WhatsApp',
      phone: 'Mobile phone',
      offline: 'Offline',
      wolt: 'Wolt',
      website: 'Website',
      telegramBot: 'Telegram Bot',
    },
    telegram: {
      postedInTelegram: 'Posted in Telegram',
      toggleToPost: 'Toggle to post/remove from Telegram channel',
      postToTg: 'Post to TG',
      unpostFromTg: 'Unpost from TG',
      inTg: 'In TG',
      currentImage: 'Current Image',
      replaceImage: 'Replace image',
      notifications: {
        posted: 'Posted %{count} product(s) to Telegram',
        postError: 'Error posting products to Telegram',
        unposted: 'Unposted %{count} product(s) from Telegram',
        unpostError: 'Error unposting products from Telegram',
        invalidPercentage: 'Please enter a valid percentage',
        priceAdjusted: '%{action} price for %{count} product(s) by %{percentage}%',
        priceAdjustError: 'Error adjusting prices',
      },
    },
    mobileOrder: {
      updateStatus: 'Update Status',
      status: {
        pending: 'Pending',
        confirmed: 'Confirmed',
        preparing: 'Preparing',
        ready: 'Ready',
        delivering: 'Delivering',
        delivered: 'Delivered',
        cancelled: 'Cancelled',
      },
      // D2.5 — custom-bouquet detail block
      customBouquet: {
        tag: 'CUSTOM',
        fallbackTitle: 'Custom bouquet',
        tier: 'Tier %{code}',
        stems: 'Stems',
        stemsSubtotal: 'Stems subtotal',
        lineTotal: 'Line',
        assembly: 'Assembly',
        customization: 'Customization',
        customizationSubtotal: 'Customization subtotal',
        snapshotTotal: 'Custom bouquet total',
        snapshotMissing:
          'Snapshot not available. The admin order-detail endpoint must embed `customCompositions[%{id}]` for full details to render here.',
        wrap: 'Wrap',
        ribbon: 'Ribbon',
        box: 'Box',
        card: 'Card',
        none: 'None',
      },
    },
    product: {
      currentPhoto: 'Current Photo',
      replacePhoto: 'Replace photo',
      uploadImage: 'Upload image (optional)',
      uploadPhotos: 'Upload photos',
      chooseColor: 'Choose a color or enter hex (e.g. #FF3366)',
      hexColor: 'Hex Color',
      removePhoto: 'Remove photo',
      priceCZK: 'Price (CZK)',
      availableAll: 'Available (All)',
      availableBranch: 'Available (%{branch})',
      trackInventory: 'Track inventory',
      trackInventoryHint: 'Turn off for items without real stock (delivery, service fees, gift wrap).',
      notTracked: 'Not tracked',
    },
    client: {
      source: {
        instagram: 'Instagram',
        telegram: 'Telegram',
        whatsapp: 'WhatsApp',
        mobile_phone: 'Mobile Phone',
        offline: 'Offline',
        wolt: 'Wolt',
        website: 'Website',
        telegram_bot: 'Telegram Bot',
      },
    },
    clientStats: {
      title: 'Client Metrics',
      lifetimeValue: 'Lifetime Value',
      totalOrders: 'Total Orders',
      avgOrderValue: 'Average Order',
      lastOrder: 'Last Order',
      favoriteSource: 'Preferred channel',
      churnRisk: {
        active: 'Active',
        atRisk: 'At risk',
        churned: 'Needs re-engagement',
        noOrders: 'No orders yet',
      },
    },
    clientWishlist: {
      title: 'Wishlist',
      product: 'Product',
      price: 'Price',
      savedAt: 'Saved',
      empty: 'This client has not saved any products yet.',
      deletedProduct: 'Product deleted',
      loadError: 'Failed to load wishlist',
    },
    referrals: {
      title: 'Referrals',
      loadError: 'Failed to load referrals',
      points: 'pts',
      status: {
        pending: 'Pending',
        settled: 'Settled',
        reversed: 'Reversed',
      },
      code: {
        label: 'Referral code',
        none: 'No referral code minted for this client yet.',
        createdAt: 'Created',
        disabledAt: 'Disabled',
        disabledLabel: 'Disabled',
        disable: 'Disable',
        enable: 'Enable',
        disabled: 'Referral code disabled.',
        enabled: 'Referral code re-enabled.',
        toggleFailure: 'Failed to toggle referral code.',
      },
      asReferrer: {
        heading: 'As referrer',
        empty: 'This client has not brought in any referees yet.',
      },
      asReferee: {
        heading: 'As referee',
        title: 'Referred by',
        mintedPromo: 'Minted promo',
        promoUsed: 'used',
        promoUnused: 'unused',
      },
      columns: {
        referee: 'Referee',
        appliedAt: 'Applied',
        status: 'Status',
        qualifyingOrder: 'Qualifying order',
        unknownClient: 'Client deleted',
      },
      reverse: {
        button: 'Reverse',
        title: 'Manually reverse referral',
        explainer: 'This claws back the 150-point referrer bonus and stamps the attribution as reversed. The reason is persisted on the row (prefixed with manual:) and recorded in the admin audit log.',
        reasonLabel: 'Reason (required)',
        reasonHelp: 'Minimum %{min} characters. Will be visible in the audit log.',
        reasonTooShort: 'Reason must be at least %{min} characters.',
        confirm: 'Reverse referral',
        submitting: 'Reversing...',
        success: 'Referral reversed and 150 points clawed back.',
        failure: 'Failed to reverse referral.',
      },
    },
    composition: {
      skuAutoGenerated: 'A unique SKU code will be generated automatically',
      skuHint: 'Unique identifier synced across all platforms',
      amountCalculated: 'Calculated automatically from composition products',
      isAddonHelp: 'Shows this product in the cart "Add a little extra" upsell section instead of the regular catalog (chocolates, balloons, cards, vases).',
      products: 'Products in Composition',
      searchProducts: 'Search products to add...',
      noProducts: 'No products added yet',
      productsCount: '%{count} product(s)',
      generateContent: 'Generate with AI',
      regenerateContent: 'Regenerate',
      generating: 'Generating...',
      generateError: 'Failed to generate content. Please try again.',
      generateNoPhotos: 'Upload photos first to generate content',
      generateHint: 'AI will analyze your photos and suggest a title and description',
      saveFirstToGenerate: 'Save the composition with photos first, then use AI to generate content',
      priceAutoComputed: 'Auto-computed from products',
      priceOverridden: 'Manually overridden',
      resetToComputed: 'Reset to computed',
    },
    category: {
      categoryName: 'Category name',
    },
    promo: {
      description: 'Description of the promo code',
      promoCode: 'Promo code',
    },
    user: {
      autoGeneratedPassword: 'Auto-generated password. You can modify it if needed.',
      leaveEmptyPassword: 'Leave empty to keep current password',
    },
    bulk: {
      increasePrice: 'Increase Price',
      decreasePrice: 'Decrease Price',
      increase: 'Increase',
      decrease: 'Decrease',
      percentage: 'Percentage',
      changeStatus: 'Change status (%{count})',
      statusUpdated: 'Updated %{count} order(s) to "%{status}"',
      statusUpdateFailed: 'Failed to update some orders',
      statusUpdateSingleFailed: 'Failed to update status',
    },
    migration: {
      importProducts: 'Import Products from Dotykacka CSV',
      importCategories: 'Import Categories from Dotykacka CSV',
      uploadCsv: 'Upload CSV',
      importButton: 'Import %{count} Products',
      importCategoriesButton: 'Import %{count} Categories',
      importing: 'Importing...',
      importCompleted: 'Import completed: %{success} products imported successfully',
      importCategoriesCompleted: 'Import completed: %{success} categories imported successfully',
      failed: '%{count} failed',
      encoding: 'Encoding',
      utf8: 'UTF-8',
      windows1250: 'Windows-1250 (Czech)',
      productsDescription: 'Upload a CSV file with columns: name (product name), priceWithVAT (price), and optionally categoryName (will match existing categories). Amount will be set to 0.',
      categoriesDescription: 'Upload a CSV file with column: name (category name).',
      notFound: 'not found',
      number: '#',
      name: 'Name',
      amount: 'Amount',
    },
    board: {
      listView: 'List view',
      boardView: 'Board view',
      noOrders: 'No orders',
      today: 'Today',
      tomorrow: 'Tomorrow',
      weddingEvent: 'Wedding event',
      subtitle: '%{count} active orders',
      moveTo: 'Move to',
    },
    telegramBot: {
      title: 'Telegram Bot',
      subtitle: 'Manage your Telegram bot integration',
      totalProducts: 'Total Products',
      activeProducts: 'Active Products',
      totalOrders: 'Total Orders',
      completedOrders: 'Completed Orders',
      inProgressOrders: 'In Progress',
      failedOrders: 'Failed',
      broadcastTitle: 'Broadcast Message',
      broadcastHint: 'Send a message to all Telegram bot users at once.',
      broadcastPlaceholder: 'Type your message to send to all bot users...',
      sendBroadcast: 'Send Broadcast',
      sending: 'Sending...',
      broadcastSuccess: 'Message sent successfully',
      broadcastError: 'Failed to send broadcast',
      recentProducts: 'Recent Bot Products',
      posted: 'Posted',
      notPosted: 'Not posted',
      noProducts: 'No products in the bot yet',
    },
    delivery: {
      title: 'Delivery Board',
      subtitle: 'Manage deliveries for',
      toPrepare: 'To Prepare',
      outForDelivery: 'Out for Delivery',
      completed: 'Completed',
      completedToday: 'Completed Today',
      noDeliveries: 'No deliveries for this date',
      markReady: 'Mark Ready',
      markDelivering: 'Start Delivery',
      markDone: 'Complete',
      recipient: 'Recipient',
      address: 'Address',
      timeSlot: 'Time Slot',
      today: 'Today',
      total: 'Total',
      remaining: 'Remaining',
      notifications: {
        loadFailed: 'Failed to load deliveries',
        statusUpdated: 'Status updated',
        statusUpdateFailed: 'Failed to update status',
      },
    },
    translations: {
      title: 'Translations',
      cs: 'Czech',
      en: 'English',
      ua: 'Ukrainian',
      ru: 'Russian',
    },
    ai: {
      generate: 'Generate with AI',
      regenerate: 'Regenerate',
      generating: 'Generating...',
      error: 'AI generation failed. Please try again.',
      generateTitle: 'Generate title with AI',
      regenerateTitle: 'Regenerate title',
      generateDescription: 'Generate description with AI',
      regenerateDescription: 'Regenerate description',
      productTitleHint: 'AI will suggest a product title from the photo, current title, and category.',
      productDescriptionHint: 'AI will suggest a description from the title, photo, and category.',
      productTitleDisabled: 'Add a photo or a current title to generate.',
      productDescriptionDisabled: 'Add a title or a photo to generate.',
    },
    advancedAnalytics: {
      title: 'Advanced Analytics',
      products: 'Product Performance',
      customers: 'Customer Insights',
      seasonal: 'Seasonal Trends',
      topProducts: 'Top Products by Revenue',
      productName: 'Product',
      unitsSold: 'Units Sold',
      revenue: 'Revenue',
      newCustomers: 'New Customers',
      returningCustomers: 'Returning Customers',
      topCustomers: 'Top Customers',
      customerName: 'Customer',
      orders: 'Orders',
      monthlyRevenue: 'Monthly Revenue (Last 12 Months)',
    },
    common: {
      created: 'Created',
      updated: 'Updated',
      searchByTitle: 'Search by title',
    },
    settings: {
      deliveryFee: 'Delivery fee (CZK)',
      lastUpdated: 'Last updated: %{date}',
      saved: 'Saved',
    },
    bouquetBuilder: {
      title: 'Bouquet Builder Settings',
      menu: 'Bouquet Builder',
      enabled: 'Builder enabled',
      enabledHint:
        'Master kill-switch. When off, the mobile builder screen + catalog tile are hidden.',
      live: 'Live',
      off: 'Off',
      minOrderTitle: 'Minimum order amount',
      minOrderInvalid: 'Minimum order amount must be a non-negative integer',
      tiersTitle: 'Size tiers (stem ranges + assembly fee)',
      tiersHint:
        'Tiers must cover 1..∞ with no gaps. Only the last tier may have ∞ max stems.',
      saved: 'Bouquet builder settings saved',
      lastUpdated: 'Last updated: %{date}',
      tier: {
        code: 'Code',
        minStems: 'Min stems',
        maxStems: 'Max stems',
        feeKc: 'Fee (CZK)',
        add: 'Add tier',
        infinityHint: 'Toggle ∞ (open-ended) max for the last tier',
      },
      category: {
        title: 'Categories — translations + photos',
        slug: 'Internal name',
        image: 'Placeholder photo',
        noImage: 'No image',
        titles: 'Display titles per locale',
        uploadButton: 'Upload image',
        uploadHint: 'JPG/PNG, ≤ 5 MB',
        uploadPending:
          'Image upload pending backend support (column + endpoint)',
        uploadOk: 'Image uploaded',
        saved: 'Categories saved',
        nothingChanged: 'No category changes to save',
        missingCs: 'Czech (cs) title is required for: ',
        empty: "No categories matched 'Flowers –%'. Check naming convention.",
        dirty: '%{n} unsaved',
        clean: 'All changes saved',
        backendPending:
          'Image upload + translation persistence require backend extension: (1) run migration 20260524120000 to add categories.image_url, (2) extend UpdateCategoryDto to whitelist `translations` and `image_url`, (3) add POST /categories/:id/image multipart endpoint mirroring the campaigns pattern.',
      },
    },
  },
};

export default customEnglishMessages;
